'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _MessageInfo = require('./MessageInfo');

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

var _MessageListAvatar = require('./MessageListAvatar');

var _MessageListAvatar2 = _interopRequireDefault(_MessageListAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        MessageAvatar: _MessageListAvatar2.default,
        MessageInfo: _MessageInfo2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },
    computed: {},
    methods: {
        isRepeat: function isRepeat() {
            var ml = this.ml;
            var idx = this.idx;
            var message = this.message;
            var prevMessage = ml.filteredMessages[idx - 1];

            return prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic';
        },

        isHoveringOverMessage: function isHoveringOverMessage(message) {
            return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
        },
        nickColour: function nickColour(nick) {
            if (this.ml.bufferSetting('colour_nicknames_in_messages')) {
                return TextFormatting.createNickColour(nick);
            }
            return '';
        },
        isMessage: function isMessage(message) {
            var types = ['privmsg', 'action', 'notice', 'message'];
            return types.indexOf(message.type) > -1;
        },
        userModePrefix: function userModePrefix(user) {
            return Misc.userModePrefix(user, this.ml.buffer);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageModern"]
window._kiwi_exports.components.MessageListMessageModern = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageListMessageModern.vue
// module id = QAaf
// module chunks = 1